import environment from '@src/Infra/Config';
import {GetSearch, GetSearchResponse} from '@Data/Model/Search';
import axios from 'axios';

export default function getSearch(parameters: GetSearch) {
  const url = `${environment.stream}/paragraphs/medias/codes/${parameters.mediaCode}?keyword=${parameters.keyword}&size=100`;

  return axios
    .get(url, {
      method: 'GET',
      headers: {
        'content-type': 'application/json',
        Authorization: 'Bearer ' + parameters.authorization,
      },
    })
    .then((response): GetSearchResponse => {
      const body = response.data;

      if (response.status === 200) {
        return {
          success: true,
          content: body,
        };
      } else if (response.status === 204) {
        return {
          success: true,
          content: [],
        };
      }

      return {
        success: false,
        message: response.statusText,
      };
    });
}
